import { useState } from 'react';
import { create } from 'zustand';
import { getAuth } from 'firebase/auth';
import { toast } from 'sonner';

export type SheetState =
  | null
  | { kind: 'adjust'; id: string }
  | { kind: 'transfer' }
  | { kind: 'payCard'; id?: string }
  | { kind: 'addWallet' }
  | { kind: 'editWallet'; id: string }
  | { kind: 'addLoan' }
  | { kind: 'payDebt'; id: string }
  | { kind: 'loanRate'; id: string }
  | { kind: 'editLoan'; id: string }
  | { kind: 'schedule'; id: string };

interface UI { sheet: SheetState; open: (s: NonNullable<SheetState>) => void; close: () => void }
export const useAssetsUI = create<UI>((set) => ({ sheet: null, open: (sheet) => set({ sheet }), close: () => set({ sheet: null }) }));

export const uid = () => getAuth().currentUser?.uid ?? '';

/** Chạy một hành động ghi: giữ trạng thái bận + lỗi; thành công → toast + đóng. Service cũ trả {success,error}. */
export const useAction = (onDone: () => void) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const exec = async (fn: () => Promise<{ success: boolean; error?: string; warnings?: string[] }>, okMsg: string) => {
    setError(null); setBusy(true);
    try {
      const r = await fn();
      if (!r.success) { setError(r.error ?? 'Không thực hiện được.'); return false; }
      r.warnings?.forEach(w => toast.warning(w, { duration: 7000 }));
      toast.success(okMsg); onDone(); return true;
    } catch (e) {
      setError((e as Error).message); return false;
    } finally { setBusy(false); }
  };
  return { busy, error, setError, exec };
};
